import { useMutation } from '@tanstack/react-query';
import { InsertClaim } from '../../../resources/payload';
import { POST, POST_INSERT_CLAIM } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { navigateTo } from '../../../utils/navigation';

export const onUploadFile = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertClaim(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await POST(POST_INSERT_CLAIM(), formData);
      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'ยื่นเคลมสำเร็จ' });
      setTimeout(() => {
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_HOME.PATH,
        });
      }, 1500);
    },
  });
  return { mutate, loading: isPending };
};
